import React from "react";
import { Plus } from "lucide-react";

export default function Fab({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="add-transaction-fab"
      aria-label="Agregar movimiento"
      title="Agregar movimiento"
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 6rem)" }}
      className="fixed z-40 right-5 sm:right-[max(1.25rem,calc(50%-13rem+1.25rem))] h-14 w-14 rounded-full bg-sage-900 text-bone flex items-center justify-center shadow-fab hover:scale-105 active:scale-95 transition-transform"
    >
      <Plus size={26} strokeWidth={2.4} />
    </button>
  );
}
